import React from "react";
import Box from "@mui/material/Box";
import Projectcolors from "../Utils/Colors";
import { baseURL } from "../Config/config";
import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Button } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Alert } from "@mui/material";
import { Paper } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import GlobalLoader from "./CommonC/GlobalLoader";
import Tooltip from "@mui/material/Tooltip";
import model from "../images/model.png";
import Arrow from "../images/arrow.png";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import LinearProgress from "@mui/material/LinearProgress";
import PropTypes from "prop-types";
import axios from "axios";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          sx={{ fontSize: 14 }}
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

function BuildModel(props) {
  const [independent, setIndependent] = React.useState([]);
  const [dependent, setDependent] = React.useState([]);
  const [count, setCount] = React.useState([]);
  const [dependentalgo, setDependentAlgo] = React.useState([]);
  const [algorithm, setAlgorithm] = React.useState([
    "lasso",
    "linear",
    "polynomial",
    "randomforestregressor",
    "knregressor",
    "decisiontreeregressor",
    "multilasso",
    "logistic",
    "xgboost",
    "svm",
    "mlp",
  ]);

  const [algorithmshort, setAlgorithmshort] = React.useState([
    "MBCV",
    "MBLR",
    "MBPR",
    "MBRF",
    "MBKN",
    "MBDT",
    "MBML",
    "MBKNN",
    "MBX",
    "MBSVM",
    "MBMLP",
  ]);

  const [index, setIndex] = React.useState();
  const [unitsin, setunitsin] = React.useState([]);
  const [unitsde, setunitsde] = React.useState([]);
  const [trained, setTrained] = React.useState(false);
  const [test, setTest] = React.useState(0);
  const [modalTraining, setmodalTraining] = React.useState(false);
  const [allmodel, setallmodel] = React.useState([]);
  const [prevalgo, setprevalgo] = React.useState([]);
  const [cat, setcat] = React.useState([]);
  const [getLoader, setGetLoader] = React.useState(false);
  const [ann, setAnn] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [openn, setOpenn] = React.useState(false);
  const [selected, setselected] = React.useState(0);

  const [parameters, setParameters] = React.useState([
    [
      0.001,
      100,
      null,
      true,
      "auto",
      1000,
      0.0001,
      true,
      null,
      false,
      null,
      false,
      null,
      "cyclic",
    ],
    [true, true, null, false],
    [2,false,true,'C'],

    [
      100,
      "squared_error",
      null,
      2,
      1,
      0.0,
      1.0,
      null,
      0.0,
      true,
      false,
      null,
      null,
      0,
      false,
      0.0,
      null,
    ],
    [6, "uniform", "auto", 30, 2, "minkowski", null, null],
    ["squared_error", "best", null, 2, 1, 0.0, null, null, null, 0.0, 0.0],
    [
      0.001,
      100,
      null,
      true,
      1000,
      0.0001,
      true,
      null,
      false,
      null,
      null,
      "cyclic",
    ],
    [
      "l2",
      false,
      0.0001,
      1.0,
      true,
      1,
      null,
      null,
      "lbfgs",
      100,
      "auto",
      0,
      false,
      null,
      null,
    ],
    [
      "gbtree",
      0,
      0.3,
      0,
      6,
      1,
      0,
      1,
      "uniform",
      1,
      1,
      1,
      0,
      "auto",
      0.03,
      1,
      1,
      "default",
      "depthwise",
      0,
      256,
      "auto",
      1,
    ],
    ["rbf", 3, "scale", 0.0, 0.001, 1.0, 0.1, true, 200, false, -1],
    [
      "(100,100)",
      "relu",
      "adam",
      0.0001,
      "auto",
      "constant",
      0.001,
      0.5,
      200,
      true,
      null,
      0.0001,
      false,
      false,
      0.9,
      true,
      false,
      0.1,
      0.9,
      0.999,
      1e-8,
      10,
      15000,
    ],
  ]);
  const [parameterslabels, setParameterslabels] = React.useState([
    [
      "Eps",
      "N alphas",
      "Alphas",
      "Fit intercept",
      "Precompute",
      "Max iter",
      "Tol",
      "Copy X",
      "CV",
      "Verbose",
      "N jobs",
      "Positive",
      "Random state",
      "Selection",
    ],
    ["Fit intercept", "Copy X", "N jobs", "Positive"],
    ["Degree","Interaction Only","Include Bias","Order"],
    [
      "N estimators",
      "Criterion",
      "Max depth",
      "Min samples split",
      "Min samples leaf",
      "Min weight fraction leaf",
      "Max features",
      "Max leaf nodes",
      "Min impurity decrease",
      "Bootstrap",
      "oob score",
      "N jobs",
      "Random state",
      "Verbose",
      "Warm start",
      "Ccp alpha",
      "Max samples",
    ],
    [
      "N neighbors",
      "Weights",
      "Algorithm",
      "Leaf size",
      "P",
      "Metric",
      "Metric params",
      "N jobs",
    ],
    [
      "Criterion",
      "Splitter",
      "Max depth",
      "Min samples split",
      "Min samples leaf",
      "Min weight fraction leaf",
      "Max features",
      "Random state",
      "Max leaf nodes",
      "Min impurity decrease",
      "Ccp alpha",
    ],
    [
      "Eps",
      "N alphas",
      "Alphas",
      "Fit intercept",
      "Max iter",
      "Tol",
      "Copy X",
      "CV",
      "Verbose",
      "N jobs",
      "Random state",
      "Selection",
    ],
    [
      "Penalty",
      "Dual",
      "Tol",
      "C",
      "Fit intercept",
      "Intercept scaling",
      "Class weight",
      "Random state",
      "Solver",
      "Max iter",
      "Multi class",
      "Verbose",
      "Warm start",
      "N jobs",
      "l1 ratio",
    ],
    [
      "Booster",
      "Silent",
      "Eta",
      "Gamma",
      "Max depth",
      "Min child weight",
      "Max delta step",
      "Subsample",
      "Sampling Method",
      "Colsample bytree",
      "Colsample bylevel",
      "Colsample bynode",
      "Alpha",
      "Tree method",
      "Sketch eps",
      "Scale pos weight",
      "Refresh leaf",
      "Process type",
      "Grow policy",
      "Max leaves",
      "Max bin",
      "Predictor",
      "Num parallel tree",
    ],
    [
      "Kernel",
      "Degree",
      "Gamma",
      "Coef0",
      "Tol",
      "C",
      "Epsilon",
      "Shrinking",
      "Cache size",
      "Verbose",
      "Max iter",
    ],
    [
      "Hidden layer sizes",
      "Activation",
      "Solver",
      "Alpha",
      "Batch size",
      "Learning rate",
      "Learning rate init",
      "Power t",
      "Max iter",
      "Shuffle",
      "Random state",
      "Tol",
      "Verbose",
      "Warm start",
      "Momentum",
      "Nesterovs momentum",
      "Early stopping",
      "Validation fraction",
      "Beta 1",
      "Beta 2",
      "Epsilon",
      "N iter no change",
      "Max fun",
    ],
  ]);
  const [links, setlinks] = React.useState([
    "https://scikit-learn.org/stable/modules/generated/sklearn.linear_model.LassoCV.html",
    "https://scikit-learn.org/stable/modules/generated/sklearn.linear_model.LinearRegression.html",
    "https://scikit-learn.org/stable/modules/generated/sklearn.preprocessing.PolynomialFeatures.html",
    "https://scikit-learn.org/stable/modules/generated/sklearn.ensemble.RandomForestRegressor.html",
    "https://scikit-learn.org/stable/modules/generated/sklearn.neighbors.KNeighborsRegressor.html",
    "https://scikit-learn.org/stable/modules/generated/sklearn.tree.DecisionTreeRegressor.html",
    "https://scikit-learn.org/stable/modules/generated/sklearn.linear_model.MultiTaskLassoCV.html",
    "https://scikit-learn.org/stable/modules/generated/sklearn.linear_model.LogisticRegression.html",
    "https://xgboost.readthedocs.io/en/stable/parameter.html",
    "https://scikit-learn.org/stable/modules/generated/sklearn.svm.SVR.html",
    "https://scikit-learn.org/stable/modules/generated/sklearn.neural_network.MLPRegressor.html",
  ]);
  const [choosenalgo, setChoosenalgo] = React.useState([]);
  const [showinput, setshowinput] = React.useState([]);
  const [algochoosen, setalgochoosen] = React.useState(false);
  const [valueerror, setvalueerror] = React.useState("");
  const [timeseries, settimeseries] = React.useState(0);
  const [progress, setProgress] = React.useState(0);
  const tooltip = [
    [
      "float",
      "integer",
      "array",
      "boolean",
      "auto, bool or array-like of shape (n_features, n_features)",
      "integer",
      "float",
      "boolean",
      "int, cross-validation generator or iterable",
      "boolean",
      "integer",
      "boolean",
      "integer",
      '{"cyclic", "random"}',
    ],
    ["boolean", "boolean", "integer", "boolean"],
    ["int or tuple (min_degree, max_degree)","boolean","boolean","{'C', 'F'}"],
    [
      "integer",
      "{“squared_error”, “absolute_error”, “poisson”}",
      "integer",
      "integer or float",
      "integer or float",
      "float",
      "{“sqrt”, “log2”, None}, int or float",
      "integer",
      "float",
      "boolean",
      "boolean",
      "integer",
      "integer",
      "integer",
      "boolean",
      "non-negative float",
      "integer or float",
    ],
    [
      "integer",
      '{"uniform", "distance"} or callable',
      '{"auto", "ball_tree", "kd_tree", "brute"}',
      "integer",
      "integer",
      "string",
      "dictionary",
      "integer",
    ],
    [
      "{“squared_error”, “friedman_mse”, “absolute_error”, “poisson”}",
      "{“best”, “random”}",
      "integer",
      "integer or float",
      "integer or float",
      "float",
      "int, float or {“auto”, “sqrt”, “log2”}",
      "integer",
      "integer",
      "float",
      "non-negative float",
    ],
    [
      "float",
      "integer",
      "array",
      "boolean",
      "integer",
      "float",
      "boolean",
      "int, cross-validation generator or iterable",
      "boolean or integer",
      "integer",
      "integer",
      '{"cyclic", "random"}',
    ],
    [
      '{"l1", "l2", "elasticnet", "none"}',
      "boolean",
      "float",
      "float",
      "boolean",
      "float",
      'dict or "balanced"',
      "integer",
      '{"newton-cg", "lbfgs", "liblinear", "sag", "saga"}',
      "integer",
      '{"auto", "ovr", "multinomial"}',
      "integer",
      "boolean",
      "integer",
      "float",
    ],
    [
      "gbtree, gblinear or dart",
      "integer",
      "range[0,1]",
      "range[0,]",
      "positive integer",
      "positive integer",
      "positive integer",
      "range[0,1]",
      "uniform,gradient_based",
      "range[0,1]",
      "range[0,1]",
      "range[0,1]",
      "postive integer",
      "auto, exact, approx, hist, gpu_hist",
      "range[0,1]",
      "integer",
      "0 or 1",
      "default, update",
      "depthwise, lossguide",
      "positive integer",
      "positive integer",
      "cpu_predictor,gpu_predictor,",
      "positive integer",
    ],
    [
      '{"linear", "poly", "rbf", "sigmoid", "precomputed"} ',
      "integer",
      '{"scale", "auto"} or float',
      "float",
      "float",
      "float",
      "float",
      "boolean",
      "float",
      "boolean",
      "integer",
    ],
    [
      "tuple",
      '{"identity", "logistic", "tanh", "relu"}',
      '{"lbfgs", "sgd", "adam"}',
      "float",
      "integer",
      '{"constant", "invscaling", "adaptive"}',
      "float",
      "float",
      "integer",
      "boolean",
      "integer",
      "float",
      "boolean",
      "boolean",
      "float",
      "boolean",
      "boolean",
      "float",
      "float",
      "float",
      "float",
      "integer",
      "integer",
    ],
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpenn = () => {
    setOpenn(true);
  };

  const handleClosee = () => {
    setOpenn(false);
  };

  let newArray = [];
  let newparameters = [];
  let change = [];
  //dependentalgo =['lasso','lasso']
  //dependentalgo = ['linear','lasso']

  const handleChange = (event, idx) => {
    //setalgochoosen(true);
    setIndex(event.target.value);
    let index = event.target.value;
    const dataArray = Array.from(dependentalgo);
    const chosenalgoarray = Array.from(choosenalgo);
    const show = Array.from(showinput);
    dataArray[idx] = algorithm[index];
    chosenalgoarray[idx] = parameters[index];
    show[idx] = index;
    setDependentAlgo(dataArray);
    setChoosenalgo(chosenalgoarray);
    setshowinput(show);

    // let dataArray =
    //index - e.target.value
    //item to update on index- algorithm[e.target.value]
    // setDependentAlgo(dependentalgo=>[...dependentalgo,algorithm[event.target.value]]);
  };
  let timer;
  const trainmodel = () => {
    const ProjectID = sessionStorage.getItem("projectID");
    setProgress(0);
    setTrained(false);
    if (test === "" || test === null ||test === 0 || dependentalgo.length === 0) {
      setOpen(true);
    } else {
      const body = JSON.stringify({
        independent,
        dependent,
        dependentalgo,
        trainsize: test,
        ProjectID,
        allmodel,
        ann: 0,
        choosenalgo,
        showinput,
        timeseries: 0,
      });

      setmodalTraining(true);
      const config = {
        onUploadProgress: (progressEvent) => {
          let seconds = 800;
          timer = setInterval(() => {
            setProgress((prevProgress) =>
              prevProgress >= 99 ? 99 : prevProgress + 1
            );
          }, seconds);
        },
        headers: {
          "Content-Type": "application/json",
        },
      };

      try {
        axios
          .post(`${baseURL}/trainmodel`, body, config)
          .then((response) => response)
          .then((result) => {
            if (result.data.message === "error") {
              setselected(result.data.algo);
              setTrained(false);
              setmodalTraining(false);
              setvalueerror(result.data.valueerror);
              setProgress(0);
              setOpenn(true);
            } else {
              setTrained(true);
              setmodalTraining(false);
              setallmodel(result.data.allmodel);
              clearInterval(timer);
              setProgress(100);
            }
          })
          .catch((error) => {
            setmodalTraining(false);
            console.error("Error:", error);
          });
      } catch (error) {
        setmodalTraining(false);
        console.log("error", error);
      }
    }
  };

  const initializeDependentAlgo = (data) => {
    if (data.prevalgo.length > 0) {
      data.dependent.map((item, i) => {
        newArray.push(algorithm[data.prevalgo[i]]);
        setDependentAlgo(newArray);
      });
    } else {
      data.dependent.map((item, i) => {
        newArray.push("lasso");
        setDependentAlgo(newArray);
      });
    }
  };

  React.useEffect(() => {
    getBuildModel();
  }, []);

  const getBuildModel = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    fetch(
      `${baseURL}/getbuildmodel?projectID=${ProjectID}&loaded=${props.loaded}`
    )
      .then((res) => res.json())
      .then((data) => {
        setTest(data.traindata);
        setprevalgo(data.prevalgo);
        initializeDependentAlgo(data);
        setIndependent(data.independent);
        setDependent(data.dependent);
        setunitsin(data.unitsin);
        setunitsde(data.unitsde);
        setCount(data.len_all);
        setcat(data.cat);
        setGetLoader(false);
        setAnn(data.ann);
        setshowinput(data.showinput);
        setChoosenalgo(data.hyperparameters);
        settimeseries(data.timeseries);

        //setIndex(0);
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("err", err);
      });
  };

  const NextStep = () => {
    props.handleNextStep();
  };
  const handleSize = (e) => {
    setTest(e.target.value);
  };

  const handleInput = (event, i, j) => {
    let change = choosenalgo.slice();
    let arrayy = change[i].slice();
    arrayy[j] = event.target.value;
    change[i] = arrayy.slice();
    setChoosenalgo(change);

    //change[i][j] = event.target.value;
    //setchoosenalgo(chosenalgoarray);
  };
  return (
  <div>
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
    >
      <DialogTitle sx={{ color: "red", fontSize: "13px" }}>
        Train Data % Required
      </DialogTitle>
    </Dialog>

    <Dialog
      open={openn}
      onClose={handleClosee}
      aria-labelledby="alert-dialog-title"
    >
      <DialogTitle sx={{ color: "red", fontSize: "13px" }}>
        <Typography sx={{ fontSize: 15 }}>
          Parameter Input Wrong for Algorithm{" "}
          {algorithmshort[selected]}
        </Typography>

        <Typography
          sx={{
            fontSize: 13,
            color: "black",
            mt: 2,
          }}
        >
          {valueerror}
        </Typography>

        <Typography
          sx={{
            fontSize: 13,
            color: Projectcolors.primary,
            mt: 2,
          }}
        >
          Know more about {algorithmshort[selected]} Parameters:
          <a
             
            rel="noreferrer"
            href={links[selected]}
            style={{ marginLeft: 6 }}
          >
            Click Here
          </a>
        </Typography>
      </DialogTitle>
    </Dialog>

    {timeseries ? (
      <Box
        component={Paper}
        elevation={3}
        sx={{
          height: "575px",
          p: "24px",
          m: "10px 0",
          borderRadius: "22px",
          border: "2px solid #0078c9",
          boxShadow: "0 8px 25px rgba(0,120,201,.08)",
          background:
            "linear-gradient(to bottom,#ffffff,#fbfcff)",
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            color: Projectcolors.primary,
            textAlign: "center",
            mt: 25,
            fontWeight: 600,
          }}
        >
          Data Includes Time Series. Try Forecasting Algorithms.
        </Typography>
      </Box>
    ) : (
      <Box
        component={Paper}
        elevation={0}
        sx={{
          height: "740px",
          p: "24px",
          m: "2px 0",
          borderRadius: "22px",
          border: "2px solid #0078c9",
          background:
            "linear-gradient(to bottom,#ffffff,#fbfcff)",
          boxShadow: "0 8px 25px rgba(0,120,201,.08)",
        }}
      >
        {/* TRAIN DATA */}

        <Box
          sx={{
            float: "left",
            width: 380,
            display: "flex",
            alignItems: "center",
            mb:5,
            ml:4

          }}
        >
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: 600,
              mr: 1,
              ml: "10px",
            }}
          >
            Train Data %
          </Typography>

          <OutlinedInput
            onChange={handleSize}
            defaultValue={test}
            size="small"
            sx={{
              width: 140,
              height: 40,
              fontSize: "14px",

              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0078c9",
              },

              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#9e0b22",
              },

              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#0078c9",
                },
            }}
          />
        </Box>

        {/* BODY */}

        <Box
  sx={{
    mt: 6,
    px: 3,
    display: "flex",
    gap: 2,
    alignItems: "stretch",
    justifyContent: "space-between",
    width: "100%",
    minHeight: "450px",
  }}
>
  {/* Independent Variables */}
  <Paper
    elevation={6}
    sx={{
      flex:1.4,
      borderRadius:"22px",
      border:"1px solid #d9e9f7",
      position:"relative",
      minWidth:350
    }}
  >
    <Box
      sx={{
        position: "absolute",
        top: -16,
        left: 20,
        px: 2,
        py: .8,
        borderRadius: "20px",
        background: "#0078c9",
        border: "1px solid #d9e9f7",
        color:"#fff",
        fontWeight: 600,
        fontSize: 16
      }}
    >
      Independent Variables
    </Box>

    <Box
      sx={{
        p: 3,
        pt: 6,
        height: 420,
        overflowY: "auto"
      }}
    >
      {independent.map((item, i) => (
        <Box sx={{mb:2}}>
          <Typography sx={{fontSize:12}}>
            {item} ({unitsin[i]})
          </Typography>

          <img
            src={Arrow}
            style={{
              width:"100%",
              height:"28px"
            }}
          />
        </Box>
      ))}
    </Box>
  </Paper>


  {/* MODEL CARD */}
  <Paper
    elevation={8}
    sx={{
      width:340,
      borderRadius:"24px",
      display:"flex",
      flexDirection:"column",
      justifyContent:"center",
      alignItems:"center",
      border:"1px solid #d9e9f7"
    }}
  >
    <Typography
      sx={{
        fontWeight:700,
        fontSize:16,
        mb:5,
        color:"#0078c9"
      }}
    >
      SelexMB Training Model
    </Typography>

    <img
      src={model}
      style={{
        width:"80%",
        objectFit:"contain"
      }}
    />
  </Paper>


  {/* Dependent */}
  <Paper
    elevation={6}
    sx={{
      flex:1.4,
      borderRadius:"22px",
      border:"1px solid #d9e9f7",
      position:"relative",
      minWidth:380
    }}
  >
    <Box
      sx={{
        position:"absolute",
        top:-16,
        left:20,
        px:2,
        py:.8,
        borderRadius:"20px",
         background: "#0078c9",
        border: "1px solid #d9e9f7",
        color:"#fff",
        fontWeight:600
      }}
    >
      Dependent Variables
    </Box>

    <Box
      sx={{
        p:3,
        pt:6,
        height:420,
        overflowY:"auto"
      }}
    >
      {dependent.map((item,i)=>(
        <Box
          sx={{
            display:"flex",
            justifyContent:"space-between",
            alignItems:"center",
            mb:3
          }}
        >
          <Box width="45%">
            <Typography sx={{fontSize:12}}>
              {item} ({unitsde[i]})
            </Typography>

            <img
              src={Arrow}
              style={{
                width:"100%",
                height:"28px"
              }}
            />
          </Box>

          <Box width="45%">

            {cat[i] ? (
                          <div>
                             
                              <Typography sx={{ fontSize: "10px" }}>
                                {" "}
                                Select Algorithm
                              </Typography>
                              <FormControl fullWidth>
              <Select
                size="small"
                defaultValue={6}
                onChange={(e)=>handleChange(e,i)}
                sx={{
                  fontSize:"12px",
                  borderRadius:"10px",
                  "& .MuiOutlinedInput-notchedOutline":{
                    borderColor:"#0078c9"
                  }
                }}
              >
                                <MenuItem value={7} sx={{ fontSize: "11px" }}>
                                  MBKNN
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        ) : (
          <div>
                            
                              <Typography sx={{ fontSize: "10px" }}>
                                {" "}
                                Select Algorithm
                              </Typography>
                               <FormControl fullWidth>
              <Select
                size="small"
                defaultValue={prevalgo[i]}
                onChange={(e)=>handleChange(e,i)}
                sx={{
                  fontSize:"12px",
                  borderRadius:"10px",
                  "& .MuiOutlinedInput-notchedOutline":{
                    borderColor:"#0078c9"
                  }
                }}
              >
                                <MenuItem value={0} sx={{ fontSize: "11px" }}>
                                  MBCV
                                </MenuItem>
                                <MenuItem value={1} sx={{ fontSize: "11px" }}>
                                  MBLR
                                </MenuItem>
                                <MenuItem value={2} sx={{ fontSize: "11px" }}>
                                  MBPR
                                </MenuItem>
                                <MenuItem value={3} sx={{ fontSize: "11px" }}>
                                  MBRF
                                </MenuItem>
                                <MenuItem value={4} sx={{ fontSize: "11px" }}>
                                  MBKN
                                </MenuItem>
                                <MenuItem value={5} sx={{ fontSize: "11px" }}>
                                  MBDT
                                </MenuItem>
                                <MenuItem value={6} sx={{ fontSize: "11px" }}>
                                  MBML
                                </MenuItem>
                                <MenuItem value={8} sx={{ fontSize: "11px" }}>
                                  MBX
                                </MenuItem>
                                <MenuItem value={9} sx={{ fontSize: "11px" }}>
                                  MBSVM
                                </MenuItem>

                                <MenuItem value={10} sx={{ fontSize: "11px" }}>
                                  MBMLP
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        )}
                      </Box>
                    </Box>
                  
                ))}
                </Box>

  </Paper>


  {/* Hyperparameter */}
  <Paper
    elevation={6}
    sx={{
      width:360,
      borderRadius:"22px",
      border:"1px solid #d9e9f7",
      position:"relative"
    }}
  >
    <Box
      sx={{
        position:"absolute",
        top:-16,
        left:20,
        px:2,
        py:.8,
        borderRadius:"20px",
         background: "#0078c9",
        border: "1px solid #d9e9f7",
        color:"#fff",
        fontWeight:600
      }}
    >
      Hyperparameter Tuning
    </Box>


    <Box
      sx={{
        p:3,
        pt:6,
        height:420,
        overflowY:"auto"
      }}
    >
      
      {choosenalgo.map((item,i)=>
      <Box sx={{ mb: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#0078c9",
                            mb: 2,
                          }}
                        >
                          {dependent[i]}{" "}
                          {
                            algorithmshort[
                              showinput[i]
                            ]
                          }{" "}
                          Parameters
                        </Typography>
                       


        
{item.map((value,j)=>(
          <Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1.5,
    p: 1,
    borderRadius: "12px",
    transition: ".2s",

    "&:hover": {
      bgcolor: "#f8fbff",
    },
  }}
>

  {/* Parameter Name */}
  <Typography
    sx={{
      width: "45%",
      fontSize: "12px",
      fontWeight: 500,
      color: "#444",
    }}
  >
    {parameterslabels[showinput[i]][j]}
  </Typography>

  {/* Input + Info */}
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 0.5,
    }}
  >
    <OutlinedInput
      placeholder="None"
      value={value}
      onChange={(e) => handleInput(e, i, j)}
      size="small"
      sx={{
        width: "120px",
        height: "36px",
        fontSize: "12px",

        borderRadius: "12px",

        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#0078c9",
        },

        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#9e0b22",
        },

        "&.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#0078c9",
          },
      }}
    />

    {/* Info Button Added Back */}
    <Tooltip
      arrow
      placement="top"
      style={{marginLeft:1}}
      title={
        <Typography sx={{ fontSize: "11px" }}>
          {tooltip[showinput[i]][j]}
        </Typography>
      }
    >
      <IconButton
        size="small"
        sx={{
          bgcolor: "#f5f8fc",
          border: "1px solid #d7e6f2",

          "&:hover": {
            bgcolor: "#0078c9",
            color: "#fff",
          },
        }}
      >
        <InfoIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  </Box>
</Box>
      ))}
      
      
      </Box> 
      
      )}
    </Box>
  </Paper>
</Box>

        {/* FOOTER */}

        <Box
          sx={{
            display: "flex",
            justifyContent:
              "space-between",
            mt: 4,
            ml:4,
            mr:3
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 4,
            }}
          >
            <Typography fontSize={12}>
              Count: {count}
            </Typography>

            <Typography fontSize={12}>
              Independent:
              {independent.length}
            </Typography>

            <Typography fontSize={12}>
              Dependent:
              {dependent.length}
            </Typography>
          </Box>

          <Box>
  <Button
    onClick={trainmodel}
    variant="contained"
    sx={{
      mr: 2,
      width: "120px",
      height: "42px",
      minWidth: "120px",
      fontSize: "12px",
      fontWeight: 600,
      borderRadius: "12px",
      backgroundColor: Projectcolors.primary,

      "&:hover": {
        backgroundColor: "#9e0b22",
      },
    }}
  >
    Train
  </Button>

           <Button
    onClick={NextStep}
    variant="contained"
    sx={{
      mr: 2,
      width: "120px",
      height: "42px",
      minWidth: "120px",
      fontSize: "12px",
      fontWeight: 600,
      borderRadius: "12px",
      backgroundColor: Projectcolors.primary,

      "&:hover": {
        backgroundColor: "#9e0b22",
      },
    }}
  >
              <ChevronRightIcon />
            </Button>

          </Box>

         
        </Box>
        <Box sx={{ml:4}}>
 {trained && (
          <Alert
            sx={{
              mt: 2,
              width: "30%",
              fontSize:12
            }}
            severity="success"
          >
            Model Trained Successfully
          </Alert>
        )}

        {(trained || modalTraining) && (
          <Box mt={2}>
            <LinearProgressWithLabel
              value={
                trained ? 100 : progress
              }
            />
          </Box>
        )}
        </Box>
        
      </Box>
    )}

    {getLoader ? <GlobalLoader /> : null}
  </div>
);
}

export default BuildModel;
